import { saveItem } from "action/shopping-cart/saveItem";
import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import classNames from "classnames";
import PAButton, { BUTTON_TYPE } from "component/design-system/buttons/PAButton";
import { VEHICLE_FITMENT } from "constant/shared-constants";
import { RootState } from "interfaces/generics.type";
import { useDispatch, useSelector } from "react-redux";
import { isApparelProduct } from "util/product/apparel";
import styles from "./saved-for-later.module.scss";

interface ISaveForLaterProps {
  product: ICompactProduct;
}

function SaveForLater(props: ISaveForLaterProps) {
  const { product } = props;
  const { savedItems } = useSelector((store: RootState) => store.shoppingCart);
  const isThisSavedItem = savedItems.some((item: any) => item.sku === product.sku);
  const { selectedVehicle } = useSelector((store: RootState) => store.garage);
  const dispatch = useDispatch();
  const isApparel = isApparelProduct(product);

  const handleSaveForLater = () => {
    const saveOrRemove = !isThisSavedItem;
    dispatch(saveItem(
      product,
      selectedVehicle,
      null,
      saveOrRemove ? (product.fitment === VEHICLE_FITMENT.UNIVERSAL || isApparel) : true,
      saveOrRemove ? 1 : 0,
    ));
  };

  return (
    <PAButton
      buttonType={BUTTON_TYPE.NORMAL}
      className={`btn ${styles.save_for_later_btn}`}
      onClick={handleSaveForLater}
    >
      <i className={classNames("fa", {
        "fa-heart": isThisSavedItem,
        "fa-heart-o": !isThisSavedItem,
      })}
      />
    </PAButton>
  );
}

export default SaveForLater;
